import _ from 'underscore';
import styled, { useTheme } from 'styled-components';

export default function SkeletonPulse({
  count = 1,
  width = null,
  height = null,
  circle = null,
  className = null,
  wrapper: CustomItemWrapper = null,
  baseColorValue = 100,
  highlightColor = 50,
}) {
  const theme = useTheme();
  const SkeletonItemWrapper = CustomItemWrapper || DefaultSkeletonWrapper;
  return (
    <SkeletonWrapper className={className} $width={width}>
      {_.times(count, (idx) => (
        <SkeletonItemWrapper
          key={idx}
          $width={width}
          $height={height}
          $circle={circle}
          $baseColor={theme.colors.surface[baseColorValue]}
          $highlightColor={theme.colors.surface[highlightColor]}
        >
          &zwnj;
        </SkeletonItemWrapper>
      ))}
    </SkeletonWrapper>
  );
}

export const DefaultSkeletonWrapper = styled.div`
  background-color: ${({ $baseColor }) => $baseColor};
  background-image: ${({ $baseColor, $highlightColor }) =>
    `linear-gradient(90deg, ${$baseColor}, ${$highlightColor}, ${$baseColor})`};
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: ${({ borderRadius, $circle }) => {
    if ($circle) return '50%';
    return borderRadius || '8px';
  }};
  display: inline-block;
  box-sizing: border-box;
  line-height: 1;

  height: ${({ $height }) => ($height ? `${$height}px` : '100%')};
  width: ${({ $width }) => ($width ? `${$width}px` : '100%')};

  animation: pulse 1.2s ease-in-out infinite;

  @keyframes pulse {
    0% {
      background-position: -200px 0;
    }
    100% {
      background-position: calc(200px + 100%) 0;
    }
  }
`;

const SkeletonWrapper = styled.div`
  width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
  height: 100%;
  line-height: 1;
  box-sizing: border-box;
`;
